import React, { memo } from 'react'
import map from 'ramda/src/map'
import withStyles from '@material-ui/core/styles/withStyles'
import Terms from 'root/src/client/web/base/StaticLayout'
import styles from './style'
import Anchors from './Anchors'
import pageContent from './pageContent'

const FAQ = memo(({ classes }) => (
	<Terms>
		<Anchors classes={classes} />
		{map(({ id, items, sectionTitle }) => (
			<section className={classes.section} id={id} key={id}>
				<h3 className={classes.sectionTitle}>
					<strong>{sectionTitle}</strong>
				</h3>
				{map(({ title, id: subSectionId, content }) => (
					<section className={classes.section} id={subSectionId} key={subSectionId}>
						<h3 className={classes.sectionTitle}>{title}</h3>
						{content}
					</section>
				), items)}
				<br />
			</section>
		), pageContent)}
	</Terms>
))

export default withStyles(styles, { name: 'MuiFAQ' })(FAQ)
